import type { ReactNode } from "react"

interface SettingSectionProps {
  title: string
  description?: string
  preview?: ReactNode
  children: ReactNode
}

function SettingSection(props: SettingSectionProps) {
  const { title, description, preview, children } = props

  return (
    <div className="flex items-start gap-12 py-5 border-b border-border last:border-b-0">
      <div className="flex flex-col gap-3 flex-1">
        <div>
          <p className="text-sm font-medium">{title}</p>
          {description && (
            <p className="text-sm text-muted-foreground mt-0.5 max-w-[500px]">
              {description}
            </p>
          )}
        </div>
        {children}
      </div>

      {preview && <div className="w-96 shrink-0">{preview}</div>}
    </div>
  )
}

export default SettingSection
